import {
    ReactNode, useMemo, useReducer,
} from 'react';

import { EntityContext, entityReducer } from 'Screens/Dashboard/AllEntities/EntityProvider/EntityContext';
import { EntityDto } from 'api/dtos/entity';

export const EditEntityProvider = (
    { children, currentEntity }: { children: ReactNode, currentEntity: EntityDto },
) => {
    const [state, dispatch] = useReducer(entityReducer, {
        name: currentEntity.name,
        email: currentEntity.email ?? '',
        phoneNumber: currentEntity.phoneNumber ?? '',
        website: currentEntity.website ?? '',
        tags: currentEntity.tags?.map((tag) => ({
            name: tag.name,
            id: tag.id,
            isRequired: tag.isRequired,
        })) ?? [],
        isEdit: true,
        isSubgroup: currentEntity.isChild,
        parentId: currentEntity.parentId ?? null,
        usesPoints: currentEntity.usesPoints,
        isIndependent: currentEntity.isIndependent,
    });

    const value = useMemo(() => ({ state, dispatch }), [state, dispatch]);

    return (
        <EntityContext.Provider value={value}>
            {children}
        </EntityContext.Provider>
    );
};
